import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Dashboard", -1)
const _hoisted_6 = { class: "ui-flex-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Meu Negócio", -1)
const _hoisted_8 = { class: "ui-flex-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Produtos", -1)
const _hoisted_10 = { class: "ui-flex-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Preços", -1)
const _hoisted_12 = { class: "ui-flex-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Clientes", -1)
const _hoisted_14 = { class: "ui-flex-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Pedidos", -1)
const _hoisted_16 = { class: "ui-flex-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Pagamentos", -1)
const _hoisted_18 = { class: "ui-flex-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Entregas", -1)
const _hoisted_20 = { class: "ui-flex-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Conteúdos", -1)
const _hoisted_22 = { class: "ui-flex-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "Integrações", -1)
const _hoisted_24 = { class: "ui-flex-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "Configurações", -1)
const _hoisted_26 = { class: "ant-row" }
const _hoisted_27 = { class: "ant-col ant-col-xs-14 ant-col-xl-1" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-1 ant-col-xl-18 ui-d-none-mob" }, null, -1)
const _hoisted_29 = { class: "ant-col ant-col-xs-10 ant-col-xl-5" }
const _hoisted_30 = { class: "ui-dados-usuario" }
const _hoisted_31 = { class: "ui-dados-usuario-identificacao" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_icone = _resolveComponent("icone")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (!_ctx.storeApp.state.carregando)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.storeApp.state.forcaVendas)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_router_view, null, {
                default: _withCtx(({ Component }) => [
                  _createVNode(_Transition, {
                    name: "fade",
                    mode: "out-in"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createBlock(_component_a_layout, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_layout_sider, {
                  class: "ui-sider",
                  theme: "light",
                  breakpoint: "lg",
                  "collapsed-width": "0",
                  collapsed: _ctx.collapsed,
                  "onUpdate:collapsed": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.collapsed) = $event)),
                  trigger: null,
                  collapsible: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("img", {
                        itemprop: "image",
                        class: "ui-logo",
                        src: _ctx.storeApp.state.parceiroAutenticado.logo,
                        alt: "Logo"
                      }, null, 8, _hoisted_4),
                      _createTextVNode(" Commerce ")
                    ]),
                    _createVNode(_component_a_menu, {
                      selectedKeys: _ctx.selectedKeys,
                      "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedKeys) = $event)),
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_menu_item, { key: "1" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              class: "ui-flex-center",
                              to: { name: 'Dashboard' }
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_icone, {
                                  class: "ui-menu",
                                  nome: "dashboard"
                                }),
                                _hoisted_5
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.storeApp.getters.verificarPrivilegioUsuario('MEU_NEGOCIO'))
                          ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_router_link, { to: { name: 'MeuNegocio' } }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_6, [
                                      _createVNode(_component_icone, {
                                        class: "ui-menu",
                                        nome: "meu-negocio"
                                      }),
                                      _hoisted_7
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.storeApp.getters.verificarPrivilegioUsuario('PRODUTOS'))
                          ? (_openBlock(), _createBlock(_component_a_sub_menu, { key: "3" }, {
                              title: _withCtx(() => [
                                _createElementVNode("div", _hoisted_8, [
                                  _createVNode(_component_icone, {
                                    class: "ui-menu",
                                    nome: "produtos"
                                  }),
                                  _hoisted_9
                                ])
                              ]),
                              default: _withCtx(() => [
                                (_ctx.storeApp.getters.verificarPrivilegioUsuario('PRODUTOS'))
                                  ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                      class: "ui-menu-item",
                                      key: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_router_link, { to: { name: 'Produtos' } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Produtos ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.storeApp.getters.verificarPrivilegioUsuario('PROD_MARCAS'))
                                  ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                      class: "ui-menu-item",
                                      key: "5"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_router_link, { to: { name: 'Marcas' } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Marcas ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.storeApp.getters.verificarPrivilegioUsuario('PROD_CATEGORIAS'))
                                  ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                      class: "ui-menu-item",
                                      key: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_router_link, { to: { name: 'Categorias' } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Categorias ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.storeApp.getters.verificarPrivilegioUsuario('PROD_CARACTERISTICAS'))
                                  ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                      class: "ui-menu-item",
                                      key: "7"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_router_link, { to: { name: 'Caracteristicas' } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Características ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.storeApp.getters.verificarPrivilegioUsuario('PRECOS'))
                          ? (_openBlock(), _createBlock(_component_a_sub_menu, { key: "8" }, {
                              title: _withCtx(() => [
                                _createElementVNode("div", _hoisted_10, [
                                  _createVNode(_component_icone, {
                                    class: "ui-menu",
                                    nome: "precificacao"
                                  }),
                                  _hoisted_11
                                ])
                              ]),
                              default: _withCtx(() => [
                                (_ctx.storeApp.getters.verificarPrivilegioUsuario('REGRAS_PRECOS'))
                                  ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                      class: "ui-menu-item",
                                      key: "9"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_router_link, { to: { name: 'RegrasPrecos' } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Regras de Preços ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.storeApp.getters.verificarPrivilegioUsuario('PRECOS'))
                                  ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                      class: "ui-menu-item",
                                      key: "10"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_router_link, { to: { name: 'TabelaPrecos' } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Tabelas de Preços ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.storeApp.getters.verificarPrivilegioUsuario('PRECOS'))
                                  ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                      class: "ui-menu-item",
                                      key: "11"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_router_link, { to: { name: 'Precos' } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Cadastro de Preços ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.storeApp.getters.verificarPrivilegioUsuario('CLIENTES'))
                          ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_router_link, { to: { name: 'Clientes' } }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_12, [
                                      _createVNode(_component_icone, {
                                        class: "ui-menu",
                                        nome: "clientes"
                                      }),
                                      _hoisted_13
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.storeApp.getters.verificarPrivilegioUsuario('PEDIDOS'))
                          ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "13" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_router_link, { to: { name: 'Pedidos' } }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_14, [
                                      _createVNode(_component_icone, {
                                        class: "ui-menu",
                                        nome: "pedidos"
                                      }),
                                      _hoisted_15
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.storeApp.getters.verificarPrivilegioUsuario('FORMAS_PAGAMENTOS'))
                          ? (_openBlock(), _createBlock(_component_a_sub_menu, { key: "14" }, {
                              title: _withCtx(() => [
                                _createElementVNode("div", _hoisted_16, [
                                  _createVNode(_component_icone, {
                                    class: "ui-menu",
                                    nome: "pagamentos"
                                  }),
                                  _hoisted_17
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_a_menu_item, {
                                  class: "ui-menu-item",
                                  key: "15"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_router_link, { to: { name: 'FormasPagamentos' } }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Formas de Pagamentos ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_menu_item, {
                                  class: "ui-menu-item",
                                  key: "16"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_router_link, { to: { name: 'Transacoes' } }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Transações ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.storeApp.getters.verificarPrivilegioUsuario('FORMAS_ENTREGAS'))
                          ? (_openBlock(), _createBlock(_component_a_sub_menu, { key: "17" }, {
                              title: _withCtx(() => [
                                _createElementVNode("div", _hoisted_18, [
                                  _createVNode(_component_icone, {
                                    class: "ui-menu",
                                    nome: "entregas"
                                  }),
                                  _hoisted_19
                                ])
                              ]),
                              default: _withCtx(() => [
                                (_ctx.storeApp.getters.verificarPrivilegioUsuario('FORMAS_ENTREGAS'))
                                  ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                      class: "ui-menu-item",
                                      key: "18"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_router_link, { to: { name: 'FormasEntregas' } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Formas de Entregas ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.storeApp.getters.verificarPrivilegioUsuario('REGRAS_FRETES'))
                                  ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                      class: "ui-menu-item",
                                      key: "19"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_router_link, { to: { name: 'RegrasFretes' } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Regras de Fretes ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.storeApp.getters.verificarPrivilegioUsuario('CONTEUDOS'))
                          ? (_openBlock(), _createBlock(_component_a_sub_menu, { key: "20" }, {
                              title: _withCtx(() => [
                                _createElementVNode("div", _hoisted_20, [
                                  _createVNode(_component_icone, {
                                    class: "ui-menu",
                                    nome: "conteudo"
                                  }),
                                  _hoisted_21
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_a_menu_item, {
                                  class: "ui-menu-item",
                                  key: "21"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_router_link, { to: { name: 'PersonalizacoesBanners' } }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Banners ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_menu_item, {
                                  class: "ui-menu-item",
                                  key: "22"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_router_link, { to: { name: 'Paginas' } }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Páginas ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_menu_item, {
                                  class: "ui-menu-item",
                                  key: "23"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_router_link, { to: { name: 'Posts' } }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Posts ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_menu_item, {
                                  class: "ui-menu-item",
                                  key: "24"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_router_link, { to: { name: 'LandingPages' } }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Landing Pages ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.storeApp.getters.verificarPrivilegioUsuario('CONFIGURACOES'))
                          ? (_openBlock(), _createBlock(_component_a_sub_menu, { key: "25" }, {
                              title: _withCtx(() => [
                                _createElementVNode("div", _hoisted_22, [
                                  _createVNode(_component_icone, {
                                    class: "ui-menu",
                                    nome: "integracoes"
                                  }),
                                  _hoisted_23
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_a_menu_item, {
                                  class: "ui-menu-item",
                                  key: "26"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_router_link, { to: { name: 'Erp' } }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" ERP ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_menu_item, {
                                  class: "ui-menu-item",
                                  key: "27"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_router_link, { to: { name: 'Marketplaces' } }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Marketplaces ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.storeApp.getters.verificarPrivilegioUsuario('CONFIGURACOES'))
                          ? (_openBlock(), _createBlock(_component_a_sub_menu, { key: "29" }, {
                              title: _withCtx(() => [
                                _createElementVNode("div", _hoisted_24, [
                                  _createVNode(_component_icone, {
                                    class: "ui-menu",
                                    nome: "configuracoes"
                                  }),
                                  _hoisted_25
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_a_menu_item, {
                                  class: "ui-menu-item",
                                  key: "30"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_router_link, { to: { name: 'Configuracoes' } }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Gerais ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_menu_item, {
                                  class: "ui-menu-item",
                                  key: "31"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_router_link, { to: { name: 'ConfiguracoesEmails' } }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" E-mails ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                (_ctx.storeApp.getters.verificarPrivilegioUsuario('USUARIOS'))
                                  ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                      class: "ui-menu-item",
                                      key: "32"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_router_link, { to: { name: 'Usuarios' } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Usuários ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_a_menu_item, {
                                  class: "ui-menu-item",
                                  key: "33"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("a", {
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.limparCache()))
                                    }, " Limpar Cache ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["selectedKeys"])
                  ]),
                  _: 1
                }, 8, ["collapsed"]),
                _createVNode(_component_a_layout, {
                  class: _normalizeClass(_ctx.collapsed?'':'ui-content')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_layout_header, { class: "ui-layout-navbar" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", {
                              class: _normalizeClass(_ctx.collapsed?'ui-menu-expand':'ui-menu-expand ui-f-right-mob')
                            }, [
                              (_ctx.collapsed)
                                ? (_openBlock(), _createBlock(_component_icone, {
                                    key: 0,
                                    nome: "menu-max",
                                    onClick: _cache[3] || (_cache[3] = () => (_ctx.collapsed = !_ctx.collapsed))
                                  }))
                                : (_openBlock(), _createBlock(_component_icone, {
                                    key: 1,
                                    nome: "menu-min",
                                    onClick: _cache[4] || (_cache[4] = () => (_ctx.collapsed = !_ctx.collapsed))
                                  }))
                            ], 2)
                          ]),
                          _hoisted_28,
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_a_dropdown, { trigger: ['click'] }, {
                              overlay: _withCtx(() => [
                                _createVNode(_component_a_menu, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_menu_item, { key: "25" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_router_link, { to: { name: 'UsuarioMeusDados' } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Meus dados ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_menu_item, {
                                      key: "26",
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deslogar()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Sair")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  class: "ant-dropdown-link",
                                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
                                }, [
                                  _createElementVNode("div", _hoisted_30, [
                                    _createVNode(_component_a_avatar, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.storeApp.getters.primeiraLetraUsuarioAutenticado()), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(),
                                    _createElementVNode("span", _hoisted_31, [
                                      _createTextVNode(_toDisplayString(_ctx.storeApp.getters.nomeUsuarioAutenticado()) + " ", 1),
                                      _createVNode(_component_icone, { nome: "seta-baixo" })
                                    ])
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_layout_content, { class: "ui-layout-content" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_view, null, {
                          default: _withCtx(({ Component }) => [
                            _createVNode(_Transition, {
                              name: "fade",
                              mode: "out-in"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            }))
      ]))
    : _createCommentVNode("", true)
}